/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

const convertLatLngAJLextGlobal = ( num ) => {
    if (!num || Number.isNaN(num)) {
        return 0;
    }
    return Number.parseFloat(num);
};

const panToLocationAJLext = (mapid, lat, lon) => {
	const locLat = convertLatLngAJLextGlobal(lat);
    const locLon = convertLatLngAJLextGlobal(lon)
    if(locLat !== 0  && locLon !== 0 && mapid) {
      mapid.flyTo([lat,lon],18);
    }
};

const scrollToMap = (byId) => {
	let elementToScrollTo = document.getElementById(byId);
  if(elementToScrollTo) {
	elementToScrollTo.scrollIntoView();
  }
};